import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import AurSvgIcon from '../aur-svg-icon/AurSvgIcon';
/*
Component for displaying the data of 403 Error page
*/
const AurPageError = () => {
    return (
        <div style={{ width: '100%', height: '650px' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingTop: '150px'
                }}
            >
                <Box
                    sx={{
                        height: '338px',
                        width: '480px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <AurSvgIcon src="images/permission_error.svg" />
                    <Typography className="typo-text display2_size mist-color-100 permission-error-title">
                        {t('errors.permissionError.title')}
                    </Typography>
                    <Typography className="typo-text subhead3_size mist-color-400 permission-error-desc">
                        {t('errors.permissionError.description')}
                    </Typography>
                    <Typography className='typo-text subhead5_size mist-color-900'>{t('errors.permissionError.linkName')}</Typography>
                </Box>
            </Box>
        </div>
    );
};

export default AurPageError;
